import { ref, watch } from 'vue'

type Theme = 'light' | 'dark' | 'system'

const STORAGE_KEY = 'aw-theme'

function resolveSystemTheme(): 'light' | 'dark' {
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
}

function applyTheme(theme: 'light' | 'dark'): void {
  document.documentElement.setAttribute('data-theme', theme)
}

const stored = localStorage.getItem(STORAGE_KEY) as Theme | null
const initialTheme: Theme = stored ?? 'system'

const themeRef = ref<Theme>(initialTheme)
const resolvedRef = ref<'light' | 'dark'>(
  initialTheme === 'system' ? resolveSystemTheme() : initialTheme
)

applyTheme(resolvedRef.value)

watch(themeRef, (val) => {
  localStorage.setItem(STORAGE_KEY, val)
  resolvedRef.value = val === 'system' ? resolveSystemTheme() : val
  applyTheme(resolvedRef.value)
})

window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', (e) => {
  if (themeRef.value === 'system') {
    resolvedRef.value = e.matches ? 'dark' : 'light'
    applyTheme(resolvedRef.value)
  }
})

export interface UseThemeReturn {
  theme: typeof themeRef
  resolved: typeof resolvedRef
  toggle: () => void
}

export function useTheme(): UseThemeReturn {
  return {
    theme: themeRef,
    resolved: resolvedRef,
    toggle: (): void => {
      themeRef.value = resolvedRef.value === 'light' ? 'dark' : 'light'
    },
  }
}
